import { render, staticRenderFns } from "./FormDocumentoEditar.vue?vue&type=template&id=6974339f"
import script from "./FormDocumentoEditar.vue?vue&type=script&lang=js"
export * from "./FormDocumentoEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports